var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgDuration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.035 34.035",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 4.49a.177.177 0 0 0-.176.176v1.412c0 .097.079.176.176.176h17.653c.097 0 .177-.08.177-.176V4.666a.177.177 0 0 0-.177-.176zm.35 24.88c0 .097.08.176.176.176h16.582a.176.176 0 0 0 .176-.176v-1.411a.177.177 0 0 0-.176-.177H8.726a.177.177 0 0 0-.176.177zm1.25-3.14c0 .097.08.176.176.176h1.412a.176.176 0 0 0 .176-.176v-1.958c0-.096.055-.233.122-.303l5.21-5.427a.169.169 0 0 1 .244 0l5.208 5.427c.068.07.123.207.123.303v1.958c0 .097.08.176.176.176h1.411a.177.177 0 0 0 .177-.176v-2.667a.506.506 0 0 0-.123-.304l-5.75-5.99a.186.186 0 0 1 0-.255l5.75-5.99a.507.507 0 0 0 .123-.305V7.8a.177.177 0 0 0-.177-.176h-1.41a.177.177 0 0 0-.177.176v2.21a.506.506 0 0 1-.123.304L17.14 15.74a.169.169 0 0 1-.245 0l-5.209-5.426a.506.506 0 0 1-.122-.304V7.8a.177.177 0 0 0-.176-.176H9.976A.177.177 0 0 0 9.8 7.8v2.92c0 .097.055.233.122.303l5.75 5.991a.186.186 0 0 1 0 .255l-5.75 5.99a.506.506 0 0 0-.122.304z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/Duration.b6b5b3b63d84d9033b45f9f0bb86358e.svg";
export { ForwardRef as ReactComponent };